import * as shared from "@/styles/shared";
import { useTranslation } from "react-i18next";
import * as styles from "../MeterReadingsPage.styles";
import { STATUS_BADGE, STATUS_KEYS } from "./badges";
import type { HistoryCardProps } from "./types";

const MAX_DISPLAYED_READINGS = 10;

const HistoryCard = ({ history }: HistoryCardProps) => {
  const { t } = useTranslation(["common", "meterReadings"]);

  return (
    <div className={styles.card}>
      <h2 className={styles.cardTitle}>{t("meterReadings:history.title")}</h2>
      {history.length ? (
        <div className={styles.historyList}>
          {history.slice(0, MAX_DISPLAYED_READINGS).map((r) => (
            <div key={r.id} className={styles.historyItem}>
              <div>
                <p className={shared.titleSmSemibold}>
                  {r.readingValue}
                  {r.secondaryReadingValue ? ` / ${r.secondaryReadingValue}` : ""}
                </p>
                {r.addressName && <p className={shared.mutedXs}>{r.addressName}</p>}
                <p className={shared.mutedXs}>{new Date(r.createdAt).toLocaleString()}</p>
                {r.errorMessage && <p className={styles.historyError}>{r.errorMessage}</p>}
              </div>
              <span className={STATUS_BADGE[r.status]}>{t(STATUS_KEYS[r.status])}</span>
            </div>
          ))}
        </div>
      ) : (
        <>
          <p className={shared.mutedXs}>{t("meterReadings:history.empty")}</p>
          <p className={shared.mutedXs}>{t("meterReadings:history.emptyHint")}</p>
        </>
      )}
    </div>
  );
};

export default HistoryCard;
